import React, {useContext} from "react";
import { Route } from "react-router-dom";
import classnames from "classnames";
import PizzaMenu from "./HeaderMenu.jsx";
import GuideContext from '../GuideContext';

const Header = ({ className, hideMenu, children }) => {
  const classes = classnames("header", className);
  const {isBusinessGuide} = useContext(GuideContext);

  const pizzaMenu = hideMenu ? null : (
    <PizzaMenu className="float-right header__pizza" />
  );

  return (
    <header className={classes}>
      <div className="header__logo"></div>
      <div className="header__title">
        <span>{isBusinessGuide ? "Business" : "Consumer"} Guide</span>
      </div>
      <Route path="/guide/:uuid/summary">
        <div className={"header__menu-btn"}>{pizzaMenu}</div>
      </Route>
    </header>
  );
};

export default Header;
